import type { AdminGetRoutesLocationsResDto } from "service/api/estabrookSchemas";

type LiveStatusRun = {
  status: "regular" | "delayed";
  items: AdminGetRoutesLocationsResDto[];
};

/** Preserve chronological order across repeated statuses and empty drop targets. */
export const getLiveStatusRuns = (
  locations: AdminGetRoutesLocationsResDto[],
): LiveStatusRun[] => {
  const runs: LiveStatusRun[] = [];
  locations.forEach((location) => {
    const status = location.order?.status;
    if (status !== "regular" && status !== "delayed") return;
    const last = runs[runs.length - 1];
    if (last?.status === status) last.items.push(location);
    else runs.push({ status, items: [location] });
  });
  for (const status of ["regular", "delayed"] as const) {
    if (!runs.some((run) => run.status === status))
      runs.push({ status, items: [] });
  }
  return runs;
};
